import React, { useState, useEffect, Fragment, useRef } from "react";
import { Routes, Route, useNavigate, Navigate, useParams } from "react-router-dom";
import logo from './logo.svg';
import './App.css';
import makeStyles from '@mui/styles/makeStyles';
import market from './assets/market.svg'

import axios from 'axios';
import { Card, CardContent, CardHeader, Chip, Divider, Grid, MenuItem, Modal, TextField, Tooltip } from '@mui/material';
import DashboardPage from './components/IcmrDashboard/DashboardPage';



import { Global, css } from '@emotion/react';
import GlobalStyles from '@mui/material/GlobalStyles';
import EnterStrain from "./components/StrainRepository/EnterStrain";
import StrainRepositoryLogin from "./components/StrainRepository/StrainRepositoryLogin";
import StrainDashboard from "./components/StrainRepository/StrainDashboard/StrainDashboard";
import EnterStrainRmrc from "./components/StrainRepository/EnterStrainRmrc";
import StrainDashboardNiced from "./components/StrainRepository/StrainDashboard/StrainDashboardNiced";
import StrainDashboardRmrc from "./components/StrainRepository/StrainDashboard/StrainDashboardRmrc";
import GenomeSequence from "./components/StrainRepository/StrainDashboard/GenomeSequence";
import MarketPage from "./components/IcmrDashboard/PathogenWise/MarketPage";
import HospitalPage from "./components/IcmrDashboard/PathogenWise/HospitalPage";
import StateSpecificPage from "./components/IcmrDashboard/PathogenWise/StateSpecificPage";
import AnimalPage from "./components/IcmrDashboard/PathogenWise/AnimalPage";
import IcmrDashboardLogin from "./components/IcmrDashboard/IcmrDashboardLogin";
import ASTMarket from "./components/IcmrDashboard/ASTwise/ASTMarket";
import ASTHospital from './components/IcmrDashboard/ASTwise/ASTHospital';
import ASTSsf from './components/IcmrDashboard/ASTwise/ASTSsf'
import ASTAnimal from './components/IcmrDashboard/ASTwise/ASTAnimal'

const useStyle = makeStyles({
  root: {
    "& .MuiDataGrid-columnHeaderTitle": {
      textOverflow: "clip",
      whiteSpace: "pre-wrap",
      lineHeight: 1,
      textAlign: "center"
    },
    "& .MuiDataGrid-cellContent": {
      textOverflow: "clip",
      whiteSpace: "pre-wrap",
      lineHeight: 2,
      textAlign: "center"
    },
    boxShadow: 2,
    '& .MuiTablePagination-selectLabel': {
      marginTop: 'auto'
    },
    '& .MuiTablePagination-displayedRows': {
      marginTop: 'auto'
    },
    "& .MuiTypography-string": {
      textOverflow: "clip",
      whiteSpace: "pre-wrap",
      lineHeight: 2,
      textAlign: "center"
    },

  }
});




function App() {


  return (
    <>

      <Routes>

        {/** icmr dashboard routes */}


        {/*<Route path="/" element={<DashboardPage />} ></Route>*/}
        {/*<Route path="/marketSurveillance" element={<MarketPage />}></Route>*/}
        {/*<Route path="/hospitalSurveillance" element={<HospitalPage />}></Route>*/}
        {/*<Route path="/ssfSurveillance" element={<StateSpecificPage />}></Route>*/}
        {/*<Route path="/animalSurveillance" element={<AnimalPage />}></Route>*/}
        {/*<Route path="/amrMarketSurveillance" element={<ASTMarket/>}></Route>*/}
        {/*<Route path="/amrHospitalSurveillance" element={<ASTHospital/>}></Route>*/}
        {/*<Route path="/amrssfSurveillance" element={<ASTSsf/>}></Route>*/}
        {/*<Route path="/amrAnimalSurveillance" element={<ASTAnimal/>}></Route>*/}



        {/** strain repo routes routes */}

        <Route path="/" element={<StrainRepositoryLogin />}></Route>
        <Route path="/straindashboard" element={<StrainDashboard />}></Route>
        <Route path="/enterStrain" element={<EnterStrain />}></Route>
        <Route path="/enterStrainRmrc" element={<EnterStrainRmrc />}></Route>
        <Route path="/niced" element={<StrainDashboardNiced />}></Route>
        <Route path="/rmrc" element={<StrainDashboardRmrc />}></Route>
        <Route path="/genome" element={<GenomeSequence />}></Route>
      </Routes>

      <GlobalStyles styles={{
        "& .MuiTextField-root": {

          "& .MuiFormLabel-asterisk.MuiInputLabel-asterisk": {
            color: "red",
            "&::after": {
            }
          }
        },
      }} />

    </>
  );
}

export default App;
